import { EMITTER_CONSTANTS } from '@/shared/config';
import emitter from '@/shared/lib/eventEmitter';
import { useEffect } from 'react';
import { attachRelocatedListeners, detachRelocatedListeners } from './relocatedSocketListeners';

/**
 * Keeps the relocated socket listeners bound for the lifetime of the mounting component. Attaches them immediately and again on every SOCKET_CONNECTED emitter event, and on unmount removes that subscription and detaches the handlers.
 *
 * @returns Nothing.
 */
const useRelocatedSocketListeners = () => {
  useEffect(() => {
    const subscription = emitter.addListener(
      EMITTER_CONSTANTS.SOCKET_CONNECTED,
      attachRelocatedListeners,
    );
    attachRelocatedListeners();
    return () => {
      subscription.remove();
      detachRelocatedListeners();
    };
  }, []);
};

export default useRelocatedSocketListeners;
